import { Link } from "react-router";
import { useTranslation } from "react-i18next";
import { EmptyState } from "@/components/ui";

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="p-6">
      <EmptyState
        icon="alert"
        title={t("notFound.title")}
        body={t("notFound.body")}
        action={
          <Link
            to="/projects"
            className="inline-flex h-9 items-center rounded-[var(--radius-ctl)] border border-border-strong bg-surface px-3.5 font-medium text-text no-underline hover:bg-surface-2 hover:text-text"
          >
            {t("notFound.home")}
          </Link>
        }
      />
    </div>
  );
}
